import React, { useState, useEffect, useRef } from "react";
import NavigationDrawer from "../../components/navigationDrawer";
import CustomBar from "../../components/customBar";
import AppContainer from "../../components/containers/AppContainer";
import { Button, Divider } from "@mui/material";
import { APP_ICONS } from "../../assets";
import AddIcon from "@mui/icons-material/Add";
import CategoryAdd from "./categoryAdd";
import { deleteCategory, getAllCategory } from "../../services/categoryFn";
import CustomSnackbar from "../../components/customSnackBar/customSnackBar";
import DynamicTable from "../../components/dynamicTable";
import AppLoader from "../../components/loader/loader";

const tableHeader = ["NAME", "ACTIONS"];
const displayRows = ["catagory_name", "actions_btn"]; // Corrected typo here

const Category = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);
  const snackRef = useRef(); // Reference for SnackbarAlert component

  const handleDialogOpen = () => {
    setDialogOpen(true);
    setEditData(null); // Reset editData for a new category
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setImage(null);
    setTitle("");
  };

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const response = await getAllCategory();

      if (response.data.status === "success") {
        setTableData(response.data.data);
      } else {
        snackRef.current.isOpenSnack({
          snackType: "error",
          snackMessage: `Failed to fetch categories: ${response.message}`,
        });
      }
    } catch (error) {
      snackRef.current.isOpenSnack({
        snackType: "error",
        snackMessage: "API Error: Failed to fetch categories",
      });
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleEdit = (category) => {
    setEditData(category);
    setDialogOpen(true);
  };

  const handleDelete = (id) => {
    let params = {
      acknowledged: false,
    };
    deleteCategory(id, params)
      .then((response) => {
        snackRef.current.isOpenSnack({
          snackType: "success",
          snackMessage: "Company Deleted successfully",
        });
        fetchCategories();
      })
      .catch((err) => {
        console.error("Error deleting company:", err);
      });
  };

  return (
    <NavigationDrawer>
      <AppLoader isVisible={loading} />
      <CustomBar title={"CATEGORY"} />
      <div
        style={{
          display: "flex",
          justifyContent: "right",
        }}
      >
        <CategoryAdd
          open={dialogOpen}
          onClose={handleDialogClose}
          type={editData ? "edit" : "add"}
          categoryData={editData}
          title={title}
          setTitle={setTitle}
          image={image}
          setImage={setImage}
          fetchCategories={fetchCategories} // Pass fetchCategories to refresh the table data
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleDialogOpen}
          sx={{
            width: "80px",
            margin: "10px",
          }}
        >
          <AddIcon /> Add
        </Button>
      </div>
      <AppContainer>
        <Divider />
        <DynamicTable
          tableHeader={tableHeader}
          displayRows={displayRows}
          tableData={tableData}
          showPagination={true}
          showUserMenu={true}
          handleEdit={handleEdit}
          handleDelete={(row) => handleDelete(row._id)}
        />
      </AppContainer>
      <CustomSnackbar ref={snackRef} /> {/* Snackbar for feedback */}
    </NavigationDrawer>
  );
};

export default Category;
